export const LIVE_FILTER_DEFAULT_FILTER_TIME = 300000; // 5 minues
export const LIVE_FILTER_MIN_REFETCH_WAIT_TIME = 300000; // 5 minues

export const LiveChannels = {
  NB_DEFAULT_TO_REQUEST: 200,
  NB_DEFAULT_PAGED_TO_REQUEST: 20,
};
